import { render, staticRenderFns } from "./FifthSection.vue?vue&type=template&id=8c8f3c1a&scoped=true&"
import script from "./FifthSection.vue?vue&type=script&lang=js&"
export * from "./FifthSection.vue?vue&type=script&lang=js&"
import style0 from "./FifthSection.vue?vue&type=style&index=0&id=8c8f3c1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8f3c1a",
  null
  
)

export default component.exports